import {KeyboardSymbolKind} from 'ui/keyboard';

function shapeSymbol(type: KeyboardSymbolKind, value?: string): KeyboardSymbol {
  return {
    type,
    value,
  };
}

export function createSymbol(type: KeyboardSymbolKind, value?: number): KeyboardSymbol {
  switch (type) {
    case KeyboardSymbolKind.Number:
      return shapeSymbol(type, value.toString());

    case KeyboardSymbolKind.Comma:
      return shapeSymbol(type, ',');

    default:
      return shapeSymbol(type);
  }
}
